import React from 'react'
interface CreateStarChartOrgTagFilterProps {
  listStatus: string
  onExperiences: () => void
  onStudents: () => void
}
export const CreateStarChartOrgTagFilter: React.FC<CreateStarChartOrgTagFilterProps> = ({
  listStatus,
  onExperiences,
  onStudents
}) => {
  return (
    <div className="starchart-filter-container filter-container">
      <div className="experiences " onClick={onExperiences}></div>
      <div className="students" onClick={onStudents}></div>
      {listStatus === 'experiences'
        ? (
        <div className="expsActive" style={{ left: 0 }}></div>
          )
        : (
        <div className="expsActive" style={{ left: '148px' }}></div>
          )}
    </div>
  )
}